import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c020a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "links lines" }
const _hoisted_2 = { class: "empty" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "HOME", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "DISCOGRAPHY", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "ABOUT US", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "LINKS", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "empty-logo",
        src: require('@/assets/logo-chevron.svg'),
        alt: "NEO-SANCTUM"
      }, null, 8, _hoisted_3),
      _createTextVNode(" hello ")
    ]),
    _createVNode(_component_router_link, {
      class: "lines",
      to: "/home"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "lines",
      to: "/discography"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "lines",
      to: "/about"
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "lines",
      to: "/links"
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}